// extracted by mini-css-extract-plugin
module.exports = {"accountStatus":"accountStatus__QClLq","text":"text__MI06U","reminderText":"reminderText__1KVy7","link":"link__3rd8c"};